import { Component, Inject } from '@angular/core';
import { User } from '../../../../shared/models/user';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { RolesService } from '../../../../core/services/roles.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { getImageUrlHelper } from '../../../../shared/helpers/getImageUrl';

@Component({
  selector: 'app-cargo-user-list-dialog',
  imports: [MatIconModule, MatDialogModule, CommonModule],
  templateUrl: './cargo-user-list-dialog.component.html',
  styleUrl: './cargo-user-list-dialog.component.scss'
})
export class CargoUserListDialogComponent {
  users: User[] = [];

  constructor(
    public dialogRef: MatDialogRef<CargoUserListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { cargoId: number },
    private rolesService: RolesService,
    private dialog: MatDialog,
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-dialog-container';
    this.dialogRef.updateSize('480px');
  }

  ngOnInit(): void {
    this.rolesService.getUsersRole(this.data.cargoId).subscribe((users) => {
      this.users = users;
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
